import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-10-75-12-20',
  standalone: true,
  imports: [],
  templateUrl: './cp-10-75-12-20.component.html',
  styleUrl: './cp-10-75-12-20.component.scss'
})
export class Cp10751220Component {

}
